import styled from 'styled-components'

export const BorderContainer = styled.div`
    border: 1px solid #BBBBBB;
    border-radius: 3px;
    padding: 10px;
`